export default function () {
    const $body = $('body');
    const $slideCart = $("#cart-preview-dropdown");

    function closeSlideCart() {
        $slideCart.removeClass("slideCart--visible").attr("aria-hidden", true).attr("inert", "");
        document.prevFocus.focus();
        //const customPageSkuHeader = document.querySelector('#custom-product-header');
        //const pageSkuElement = document.querySelector("#productView-details-price-header > div.productView-product > dl > dd");
        ///const personalizeButtonElement = document.querySelector("#artifi-personalize-button-container > div > input");
        // if(customPageSkuHeader){
        //     const productSku = parseInt(customPageSkuHeader.dataset.productId,10);
        //     if(productSku){
        //         BigCommerceArtifi.ProductPage.launchDesignerForVariant(productSku, '');
        //     }

        //}else
        //  if(personalizeButtonElement && pageSkuElement && BigCommerceArtifi){
        //     const pageSkuString = pageSkuElement.textContent;
        //     //BigCommerceArtifi.ProductPage.toggleArtifiDesigner(NaN);
        //     BigCommerceArtifi.ProductPage.launchDesignerForVariant(pageSkuString, '');
        // }

    }
    
    function trapFocus(e) {
        const focusableTypes = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableElements = $(focusableTypes, $slideCart);
        const firstFocusableElement = focusableElements[0]; // get first element to be focused inside modal
        const lastFocusableElement = focusableElements[focusableElements.length - 1]; // get last element to be focused inside modal

        if ( e.key === 'Escape' ) {
            closeSlideCart();
        } else if ( e.key === 'Tab' ) {
            if (e.shiftKey) { // if shift key pressed for shift + tab combination, progress backward
                if (document.activeElement === firstFocusableElement) {
                    e.preventDefault();
                    console.log("tabbing backward");
                    lastFocusableElement.focus(); // add focus for the last focusable element
                }
            } else { // if only tab key is pressed, progress forward
                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    e.preventDefault();
                    console.log("tabbing forward");
                    firstFocusableElement.focus(); // add focus for the first focusable element
                }
            }
        }
    }

    // Only create event listeners once
    if( !document.slideCartInitiated ) {
        $("#slideCartClose, #slideCartOverlay").on("click", () => {
            closeSlideCart();
        });

        window.addEventListener('keydown', function (e) {            
            if ( $slideCart.hasClass("slideCart--visible" ) ) {
                trapFocus(e);
            }
        })
    
        $slideCart.on("transitionstart", (e) => {
            if(e.originalEvent.propertyName == "transform") {
                if($slideCart.hasClass("slideCart--visible")) {
                    $body.addClass("no-scroll");
                } else {
                    $body.removeClass("no-scroll");
                }
            }
        });
        document.slideCartInitiated = true;
    }

    $slideCart.toggleClass("slideCart--visible").attr("aria-hidden", false).removeAttr("inert");
    $("#slideCartClose").focus();
}
